import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "empty",
    "details",
    "image",
    "imageFrame",
    "imagePlaceholder",
    "itemName",
    "sku",
    "unitName",
    "taxClassification",
    "summary"
  ]

  static values = {
    variants: Object
  }

  connect() {
    this.boundHandleChange = this.handleChange.bind(this)
    this.element.addEventListener("change", this.boundHandleChange)
    this.render()
  }

  disconnect() {
    this.element.removeEventListener("change", this.boundHandleChange)
  }

  handleChange(event) {
    if (!this.isVariantField(event.target)) return

    this.render()
  }

  render() {
    const variant = this.currentVariant()

    if (!variant) {
      this.showEmptyState()
      return
    }

    this.emptyTarget.classList.add("d-none")
    this.detailsTarget.classList.remove("d-none")

    this.itemNameTarget.textContent = variant.item_name
    this.skuTarget.textContent = variant.sku
    this.unitNameTarget.textContent = variant.unit_name
    this.taxClassificationTarget.textContent = variant.tax_classification_name
    this.summaryTarget.textContent = variant.summary

    if (variant.image_path) {
      this.imageTarget.src = variant.image_path
      this.imageTarget.alt = variant.item_name
      this.imageFrameTarget.classList.remove("d-none")
      this.imagePlaceholderTarget.classList.add("d-none")
    } else {
      this.imageTarget.removeAttribute("src")
      this.imageTarget.alt = ""
      this.imageFrameTarget.classList.add("d-none")
      this.imagePlaceholderTarget.classList.remove("d-none")
    }
  }

  showEmptyState() {
    this.detailsTarget.classList.add("d-none")
    this.emptyTarget.classList.remove("d-none")
    this.imageTarget.removeAttribute("src")
    this.imageTarget.alt = ""
    this.imageFrameTarget.classList.add("d-none")
    this.imagePlaceholderTarget.classList.remove("d-none")
  }

  currentVariant() {
    const variantId = this.variantField()?.value?.toString().trim()
    if (!variantId) return null

    return this.variantsValue[variantId] || null
  }

  variantField() {
    return this.element.querySelector("input[name$='[item_variant_id]']")
  }

  isVariantField(element) {
    return element?.matches?.("input[name$='[item_variant_id]']")
  }
}
